<template>
  <v-row>
    <v-col cols="12">
        <product-ingredient-card></product-ingredient-card> 
    </v-col>
  </v-row>
</template>
<script>
import ProductIngredientCard from "@/components/ingredient/ProductIngredientCard";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Product Ingredient List",
  },

  components: {
    ProductIngredientCard
  },

  data() {
    return {
    };
  },
};
</script>